import React from "react"
import { pgaComTld } from "../utils"
import {
  getCurrentUnixTimestamp,
  interpolate,
} from "../widgets/MembershipJourney/utils/displayUtils"
import { EVENTS_URLS } from "../widgets/MembershipJourney/utils/constants/externalUrls"
import { BACKGROUND_CHECK_PAGE_PATH } from "./ReinstatementSteps"
import { REAPPLY_REQUIREMENT_KEY } from "./associateReapplyRequirements"
import {
  Heading,
  Intro,
  Section,
  Step,
  STEP_STATUS_LABEL,
  StepLink,
  StepList,
  StepRouterLink,
  StepText,
} from "./StepsLayout"

export const REAPPLY_REQUIREMENTS_TITLE = "Requirements to Reapply"
export const FIND_PAT_LABEL = "Find a PAT"
export const PAY_DUES_LABEL = "Pay Dues"
export const START_BACKGROUND_CHECK_LABEL = "Start Background Check"

export const REAPPLY_REQUIREMENTS_ALL_COMPLETE_INTRO =
  "You have met every requirement to reapply as an Associate."

export const reapplyRequirementsIntro = (completeCount, total) =>
  completeCount === total
    ? REAPPLY_REQUIREMENTS_ALL_COMPLETE_INTRO
    : `${completeCount} of ${total} requirements complete. Complete the rest to reapply as an Associate.`

const RequirementAction = ({ requirementKey }) => {
  switch (requirementKey) {
    case REAPPLY_REQUIREMENT_KEY.PAT:
      return (
        <StepLink
          href={interpolate(EVENTS_URLS.PAT_SEARCH, {
            unixTimestamp: getCurrentUnixTimestamp(),
          })}
          target="_blank"
          rel="noopener noreferrer"
        >
          {FIND_PAT_LABEL}
        </StepLink>
      )
    case REAPPLY_REQUIREMENT_KEY.DUES:
      return (
        <StepLink
          href={`https://${pgaComTld}/member/dues/overview`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {PAY_DUES_LABEL}
        </StepLink>
      )
    case REAPPLY_REQUIREMENT_KEY.BACKGROUND_CHECK:
      return (
        <StepRouterLink to={BACKGROUND_CHECK_PAGE_PATH}>
          {START_BACKGROUND_CHECK_LABEL}
        </StepRouterLink>
      )
    default:
      return null
  }
}

const ReapplyRequirements = ({ requirements }) => {
  if (!requirements?.length) return null

  const completeCount = requirements.filter(row => row.complete).length

  return (
    <Section aria-labelledby="reapply-requirements-heading">
      <Heading id="reapply-requirements-heading">
        {REAPPLY_REQUIREMENTS_TITLE}
      </Heading>
      <Intro>
        {reapplyRequirementsIntro(completeCount, requirements.length)}
      </Intro>
      <StepList>
        {requirements.map((row, index) => (
          <Step
            key={row.key}
            number={index + 1}
            title={row.title}
            status={
              row.complete
                ? STEP_STATUS_LABEL.complete
                : STEP_STATUS_LABEL.required
            }
            complete={row.complete}
          >
            <StepText>{row.description}</StepText>
            {row.detail && <StepText>{row.detail}</StepText>}
            {!row.complete && <RequirementAction requirementKey={row.key} />}
          </Step>
        ))}
      </StepList>
    </Section>
  )
}

export default ReapplyRequirements
